import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 5, // Garbage-collect (renamed from cacheTime in v5) everything after 5 mins idle
      retry: 0, // Dont retry data, axios does that
      staleTime: 1000 * 60 * 5, // Consider queries stale only after 5 mins by default
    },
  },
});

export default queryClient;
